import { Button } from '@moveek/ui';

export function FullPageError() {
  return (
    <div className="mvk-root flex min-h-screen items-center justify-center p-6">
      <div className="max-w-md rounded-lg border border-border bg-surface p-8 text-center shadow-md">
        <h1 className="mvk-display text-2xl text-fg">Đã có lỗi xảy ra</h1>
        <p className="mt-2 text-sm text-fg-muted">
          Rất tiếc, ứng dụng đã gặp sự cố. Vui lòng tải lại trang để thử lại.
        </p>
        <Button className="mt-6" onClick={() => window.location.reload()}>
          Tải lại trang
        </Button>
      </div>
    </div>
  );
}
